
const state = {
  triggerFromA: false,

}

// mutations
const mutations = {
  //下载
  setTriggerFromA(state, value) {
    state.triggerFromA = value;
  },

  
}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/specification.js